import { changeTestWeight } from 'api/harvest'
import { unitConvert } from '@farmtrx/units'
import {
  FormControl,
  FormControlLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import { closeModal } from 'actions/app'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import ModalTool from '../modal/modal-tool'

export const getDisplayTestWeightValue = (testWeightKgHl, unit) => {
  const parsedValue = Number(testWeightKgHl)
  if (!Number.isFinite(parsedValue) || parsedValue <= 0 || !unit) {
    return ''
  }

  return Number(
    unitConvert
      .convertTestweight(parsedValue, unitConvert.KG_HL, unit)
      .toFixed(2),
  )
}

export const getKgHlTestWeightValue = (value, unit) => {
  const parsedValue = Number(value)
  if (!Number.isFinite(parsedValue) || parsedValue <= 0 || !unit) {
    return null
  }

  return unitConvert.convertTestweight(parsedValue, unit, unitConvert.KG_HL)
}

export default function ChangeTestWeight() {
  const testWeightUnit = useSelector(
    (state) => state.account.singleton.prefs.units.testweight_in,
  )
  const testWeightList = Object.keys(
    useSelector((state) => state.account.options.units.testWeight),
  )
  const selectedHarvest = useSelector((state) => state.harvest.current)
  const [type, setType] = useState(testWeightUnit ?? testWeightList[0])
  const [val, setVal] = useState('')

  const id = useSelector((state) => state.harvest.current?.id)

  const dispatch = useDispatch()

  const { t } = useTranslation()

  useEffect(() => {
    setVal(getDisplayTestWeightValue(selectedHarvest?.testWeightKgHl, type))
  }, [selectedHarvest?.id, selectedHarvest?.testWeightKgHl, type])

  const onValueChange = useCallback((e) => {
    if (e.target.value === '') {
      setVal('')
      return
    }
    const value = Number(e.target.value)
    setVal(Number.isFinite(value) ? value : '')
  })

  const onSubmit = useCallback(() => {
    const convertedValue = getKgHlTestWeightValue(val, type)
    if (convertedValue !== null) {
      dispatch(changeTestWeight(id, convertedValue))
    }
  }, [dispatch, id, type, val])

  const onUnitChange = useCallback((e) => {
    setType(e.target.value)
  })

  const closePopup = useCallback(() => {
    dispatch(closeModal())
  }, [dispatch])

  return (
    <ModalTool
      header={t('change_tw')}
      content={
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <FormControlLabel
            sx={{ flexGrow: 1 }}
            control={
              <TextField
                id="testWeight"
                sx={{ width: '25ch', padding: '10px' }}
                name="testWeight"
                variant="outlined"
                size="small"
                type="number"
                onChange={onValueChange}
                value={val}
                autoFocus
              />
            }
            label={t('test_weight')}
            labelPlacement="start"
          />
          <FormControl sx={{ padding: '10px' }}>
            <Select onChange={onUnitChange} value={type}>
              {testWeightList.map((tw) => (
                <MenuItem key={tw} value={tw}>
                  {t(tw)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      }
      onClose={closePopup}
      onApply={onSubmit}
    />
  )
}
